<div class="gdx-collapse">
  <input type="checkbox" id="{{ collapser }}" [checked]="false" />
  <label class="gdx-collapse-title" for="{{ collapser }}">
    {{ title }}
  </label>
  <div class="gdx-collapse-content">
    <ng-content></ng-content>
  </div>
</div>
